import { NO_THIRDPARTY_SCRIPT_ROUTE_PREFIXES } from '../constants';
import APIConfig from 'src/apiconfig';

// not an exhaustive list, common terms to catch in case the routes list above is out of date.
const NO_THIRD_PARTY_SCRIPT_QUERY_PARAMS = [
  'token',
  'code',
  'nonce',
  'code_challenge',
  'password',
  'auth_token',
  'access_token',
  'id_token',
  'refresh_token',
  'auth_token',
  'api_key',
  'secret',
  'otp',
  'otc',
  'verification_code',
];

export const is3rdPartyScriptsAllowedForRoute = (params: {
  pathname: string;
  queryParams: string;
}): boolean => {
  if (!APIConfig.thirdPartyScripts) {
    return false;
  }

  const publicPath = process.env.publicPath || '/';
  let appRoute = params.pathname;

  if (publicPath !== '/') {
    // remove starting and trailing slashes if there are any so we get it in
    // a known state.
    const sanitizedPublicPath = publicPath.replace(/\//g, '');

    // for test branches remove the branch path prefix.
    appRoute = appRoute.replace(`/${sanitizedPublicPath}`, '');
  }

  const isSensitiveRoute = NO_THIRDPARTY_SCRIPT_ROUTE_PREFIXES.some((prefix) =>
    appRoute.startsWith(prefix)
  );

  if (isSensitiveRoute) {
    return false;
  }

  const urlParams = new URLSearchParams(params.queryParams);
  let sensitiveQueryParamFound = false;
  for (const key of urlParams.keys()) {
    if (NO_THIRD_PARTY_SCRIPT_QUERY_PARAMS.includes(key)) {
      sensitiveQueryParamFound = true;
      break;
    }
  }

  return !sensitiveQueryParamFound;
};

const savedInitialPageLoad3rdPartyScriptsAllowed = is3rdPartyScriptsAllowedForRoute(
  {
    pathname: window.location.pathname,
    queryParams: window.location.search,
  }
);

// for index.webpack.html to be able to access it, can't import the getter function there.
(window as any).initialPageLoad3rdPartyScriptsAllowed = savedInitialPageLoad3rdPartyScriptsAllowed;

export const initialPageLoad3rdPartyScriptsAllowed = () =>
  savedInitialPageLoad3rdPartyScriptsAllowed;
